import React, { useState } from "react";
import styles from "../../../views/ReportView/ReportView.module.css";
import NotReportViewData from "../../NotReportViewData/NotReportView";
import { FaUserAlt } from "react-icons/fa";

const Personalinformation = ({ data }) => {
  const [user, setUser] = useState(data);
  const [isEditing] = useState(false);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setUser({ ...user, [name]: value });
  };

  return (
    <div className={styles.informacionPersonal} id="personal">
      <h2 className={styles.sectionTitle}>Información Personal</h2>

      {!user ? (
        <NotReportViewData title="Información Personal" Icon={FaUserAlt} />
      ) : (
        <>
          <div className={styles.nad}>
            <label className={styles.inputLabel}>
              Nombre:
              <input
                className={styles.inputField}
                type="text"
                name="nombre"
                value={user.name || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
            <label className={styles.inputLabel}>
              Apellido:
              <input
                className={styles.inputField}
                type="text"
                name="apellido"
                value={user.lastName || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
            <label className={styles.inputLabel}>
              Tipo de documento:
              <input
                className={styles.inputField}
                type="text"
                name="tipo_documento"
                value={user.documentType || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
          </div>
          <div className={styles.nad}>
            <label className={styles.inputLabel}>
              Dni:
              <input
                className={styles.inputField}
                type="text"
                name="cuil"
                value={user.dni || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
            <label className={styles.inputLabel}>
              Nacionalidad:
              <input
                className={styles.inputField}
                type="text"
                name="nacionality"
                value={user.nacionality || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
            <label className={styles.inputLabel}>
              Estado civil:
              <input
                className={styles.inputField}
                type="text"
                name="civilStatus"
                value={user.civilStatus || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
          </div>
          <div className={styles.nad}>
            <label className={styles.inputLabel}>
              CUIL:
              <input
                className={styles.inputField}
                type="text"
                name="cuil"
                value={user.cuil || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
            <label className={styles.inputLabel}>
              Fecha de nacimiento:
              <input
                className={styles.inputField}
                type="date"
                name="fecha_nacimiento"
                value={user.dateOfBirth || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
            <label className={styles.inputLabel}>
              Lugar de nacimiento:
              <input
                className={styles.inputField}
                type="text"
                name="lugar_nacimiento"
                value={user.placeOfBirth || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
          </div>
          <div className={styles.nad}>
            <label className={styles.inputLabel}>
              Teléfono:
              <input
                className={styles.inputField}
                type="tel"
                name="telefono"
                value={user.phone || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
            <label className={styles.inputLabel}>
              Correo electrónico:
              <input
                className={styles.inputField}
                type="email"
                name="correo_electronico"
                value={user.email || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
            <label className={styles.inputLabel}>
              Nivel socioeconómico:
              <input
                className={styles.inputField}
                type="text"
                name="SocioEconomicLevel"
                value={user.SocioEconomicLevel || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
          </div>
          <div className={styles.nad}>
            <label className={styles.inputLabel}>
              Calle:
              <input
                className={styles.inputField}
                type="text"
                name="street"
                value={user.street || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
            <label className={styles.inputLabel}>
              Numero:
              <input
                className={styles.inputField}
                type="text"
                name="numberStreet"
                value={user.numberStreet || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
            <label className={styles.inputLabel}>
              Codigo postal:
              <input
                className={styles.inputField}
                type="text"
                name="postalCode"
                value={user.postalCode || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
          </div>
          <div className={styles.nad}>
            <label className={styles.inputLabel}>
              Departamento:
              <input
                className={styles.inputField}
                type="text"
                name="apartment"
                value={user.apartment || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
            <label className={styles.inputLabel}>
              Piso:
              <input
                className={styles.inputField}
                type="text"
                name="floor"
                value={user.floor || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
            <label className={styles.inputLabel}>
              Localidad:
              <input
                className={styles.inputField}
                type="text"
                name="location"
                value={user.location || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
          </div>
          <div className={styles.nad}>
            <label className={styles.inputLabel}>
              Provincia:
              <input
                className={styles.inputField}
                type="text"
                name="province"
                value={user.province || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
          </div>
        </>
      )}
    </div>
  );
};

export default Personalinformation;
